import { Component, DestroyRef, Inject, ViewChild, inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';

export interface ArtistData {
  a_id: any;
}

export interface EventElement {
  a_id: string;
  image_name: string;
  artist: string;
  role: string;
  action: any;
}

@Component({
  selector: 'app-artists',
  templateUrl: './artists.component.html',
  styleUrls: ['./artists.component.scss']
})
export class ArtistsComponent {
  displayedColumns: string[] = [
    'a_id',
    'image_name',
    'artist',
    'role',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  a_result: any;
  event_id: any;
  a_id: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngAfterViewInit() {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.Get_Artist(this.event_id);
    this.dataSource.paginator = this.paginator;
  }

  AddArtist() {
    const dialogRef = this.dialog.open(add_artist, {
      data: {
        a_id: this.a_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Artist(this.event_id);
    });
  }

  EditArtist(a_id: any) {
    const dialogRef = this.dialog.open(add_artist, {
      data: {
        a_id: a_id
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Artist(this.event_id);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Artist(event_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.getArtist(event_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.a_result = data.data
        for (const item of this.a_result) {
          this.ELEMENT_DATA = this.a_result.map((item: { image_name: any; artist: any; role: any; a_id: any; }, index: number) => ({
            srNo: index + 1,
            a_id: item.a_id,
            image_name: item.image_name,
            artist: item.artist,
            role: item.role,
            action: item.a_id
          })
          );
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      }
    );
  }

  DeleteAdmin(a_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Artist?');
    if (buttonClicked === true) {

      this.service.delete_artist(a_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.a_id !== a_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Artist Deleted Succesfully");
        });
    }
  }
}


@Component({
  selector: 'add_artist',
  templateUrl: './add_artist.html',
  styleUrls: ['./artists.component.scss'],
  standalone: false
})
export class add_artist {

  ArtistForm: FormGroup;
  a_id: any
  result: any;
  hide = true;
  point: any
  private destoryRef = inject(DestroyRef);
  point_data: any;
  event_id: any;
  updated_by: any;
  artist: any;
  role: any;
  description: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_artist>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: ArtistData
  ) {
    this.a_id = data['a_id'];
    this.ArtistForm = this.member.group({
      a_id: this.a_id,
      artist: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      role: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      image_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      description: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
    });
  }

  ngOnInit(): void {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.updated_by = sessionStorage.getItem('User_ID');
    this.getArtistByID(this.a_id)
  }

  getArtistByID(a_id: any) {
    this.service.getArtistByID(a_id).subscribe(
      (data: any) => {
        this.point_data = data.data;
        this.a_id = this.point_data[0].a_id;
        this.artist = this.point_data[0].artist;
        this.role = this.point_data[0].role;
        this.image_name = this.point_data[0].image_name;
        this.description = this.point_data[0].description;
      });

    this.isOld1 = true;
  }

  previewpimage(files: any) {
    console.log(files);
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.service.uploadimage(this.imagefileURL, this.event_id + "/artist").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);
        this.isOld1 = false;
        this.ArtistForm.patchValue({
          image_name: this.imagePath
        })
      });
    };
  }

  onFormSubmit() {
    const formData = this.ArtistForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.ArtistForm.valid && hasNonEmptyField) {

      if (this.a_id) {
        this.service.edit_artist(this.ArtistForm.value, this.updated_by).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Artist Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_artist(this.ArtistForm.value, this.updated_by).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Artist Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}